import './NewsModal.scss';
import * as React from 'react';
import Icon from '../../Icon';

export interface INewsItemModalProps {
  children?: React.ReactNode;
  title?: string;
  onCloseClick: () => void;
}

const NewsItemModal = ({ children, title, onCloseClick }: INewsItemModalProps) => (
  <div className="NewsItemModalContainer px-4">
    <div className="max-w-screen-xl mx-auto">
      <div className="flex items-center justify-between my-4">
        <h1 className="uppercase font-light text-lg my-0">{title || 'Nyheder'}</h1>
        <button
          onClick={onCloseClick}
          className="flex items-center p-2 f6 font-bold uppercase cursor-pointer"
        >
          Luk
          <Icon name="cross" className="-mr-2" />
        </button>
      </div>
      <div className="flex">{children}</div>
    </div>
  </div>
);

export default NewsItemModal;



// WEBPACK FOOTER //
// ./src/components/News/NewsModal/index.tsx